'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContactSalesButton = require('ui-addon-upgrades/_core/contactSales/ContactSalesButton');

var _ContactSalesButton2 = _interopRequireDefault(_ContactSalesButton);

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

var _connectUpgradeData = require('ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData');

var _connectUpgradeData2 = _interopRequireDefault(_connectUpgradeData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTACT_SALES_BUTTON = _sources.sourceKeys.CONTACT_SALES_BUTTON;
exports.default = (0, _connectUpgradeData2.default)(_ContactSalesButton2.default, CONTACT_SALES_BUTTON);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/button/UIContactSalesButton.js
// module id = 358
// module chunks = 3 4 5